/* Bodycraft motion layer: scroll reveals (with safety net), image-section loading fix + scroll zoom, cart dot. Safe to remove. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveals ---------- */
  var pending = [];
  function contentOf(sec) {
    // The visible content of a section (skips background layers, styles and scripts).
    var kids = sec.children;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (/^(STYLE|SCRIPT|LINK|TEMPLATE)$/.test(k.tagName)) continue;
      if (k.classList.contains('section-background')) continue;
      if (k.getBoundingClientRect().height < 20) continue;
      return k;
    }
    return null;
  }
  function revealTargets() {
    var out = [];
    document.querySelectorAll('main > .shopify-section').forEach(function (sec, i) {
      if (i === 0) return;
      if (/__main$/.test(sec.id)) return;
      if (sec.getBoundingClientRect().height < 20) return;
      if (sec.querySelector('.bcr-fam')) {
        out.push({ el: sec.querySelector('.bcr-fam__card'), d: 0 });
        sec.querySelectorAll('.bcr-fam__list li').forEach(function (li, n) { out.push({ el: li, d: .15 + n * .12 }); });
        return;
      }
      var cards = sec.querySelectorAll('product-card');
      if (cards.length) {
        var head = sec.querySelector('h1, h2, h3');
        if (head && !head.closest('product-card')) out.push({ el: head, d: 0 });
        cards.forEach(function (c, n) { out.push({ el: c, d: (n % 4) * .08 }); });
        return;
      }
      var inner = contentOf(sec);
      if (inner) out.push({ el: inner, d: 0 });
    });
    return out;
  }
  function show(el) {
    if (!el.classList.contains('bcr-rv') || el.classList.contains('bcr-in')) return;
    el.classList.add('bcr-in');
    setTimeout(function () { el.classList.remove('bcr-rv', 'bcr-in'); el.style.removeProperty('--bcr-d'); }, 1600);
  }
  function showAll() { pending.forEach(show); pending = []; }
  function checkPending() {
    if (!pending.length) return;
    var vh = window.innerHeight;
    pending = pending.filter(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.94) { show(el); return false; }
      return true;
    });
  }
  function initReveals() {
    if (reduce) return;
    var vh = window.innerHeight;
    revealTargets().forEach(function (t) {
      if (!t.el || t.el.dataset.bcrRv) return;
      t.el.dataset.bcrRv = '1';
      if (t.el.getBoundingClientRect().top < vh * 0.92) return;
      t.el.style.setProperty('--bcr-d', t.d + 's');
      t.el.classList.add('bcr-rv');
      pending.push(t.el);
    });
    if (!pending.length) return;
    var ioAlive = false;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        ioAlive = true;
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          show(e.target);
          pending = pending.filter(function (p) { return p !== e.target; });
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
      pending.forEach(function (el) { io.observe(el); });
    }
    window.addEventListener('scroll', checkPending, { passive: true });
    // Safety nets: a light position check every 0.4s, and if the browser never reports visibility, show everything.
    var iv = setInterval(function () { checkPending(); if (!pending.length) clearInterval(iv); }, 400);
    setTimeout(function () { if (!ioAlive) showAll(); }, 2500);
  }

  /* ---------- image/video sections: make sure photos load, then add a slow zoom ---------- */
  var zoomEls = [];
  function initZoom() {
    document.querySelectorAll('[class*="custom-image-text"] .media-container').forEach(function (m) {
      var imgs = m.querySelectorAll('img');
      // These photos have no set height before they load, so lazy loading can skip them. Load them straight away.
      imgs.forEach(function (i) { if (i.getAttribute('loading') === 'lazy') { i.setAttribute('loading', 'eager'); } });
      if (reduce) return;
      var ready = function () {
        if (m.classList.contains('bcr-zoom-ready')) return;
        // Keep the rounded corners: the zoom is clipped by this box, so give it the same corner radius as the photo/video.
        var inner = m.querySelector(':scope > .video-wrapper') || m.querySelector(':scope > img');
        var rad = inner ? getComputedStyle(inner).borderRadius : '';
        if (rad && rad !== '0px') m.style.borderRadius = rad;
        m.classList.add('bcr-zoom-ready');
        zoomEls.push(m);
        onScroll();
      };
      if (m.querySelector('video')) { ready(); return; }
      var im = imgs[0];
      if (!im) return;
      if (im.complete && im.naturalHeight > 0) ready();
      else im.addEventListener('load', ready, { once: true });
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking || !zoomEls.length) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      zoomEls.forEach(function (m) {
        var r = m.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
        var target = m.querySelector(':scope > .video-wrapper') || m.querySelector(':scope > img');
        if (target) target.style.setProperty('--bcr-z', (1.12 - p * 0.12).toFixed(4));
      });
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- dot flies into the cart on add ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.add-to-cart-button, .quick-add__button--add');
    if (!btn || btn.disabled || reduce) return;
    var cart = document.querySelector('cart-icon') || document.querySelector('header a[href*="/cart"]');
    if (!cart) return;
    var a = btn.getBoundingClientRect(), b = cart.getBoundingClientRect();
    var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2, x1 = b.left + b.width / 2, y1 = b.top + b.height / 2;
    var d = document.createElement('div');
    d.className = 'bcr-flyer';
    document.body.appendChild(d);
    if (!d.animate) { d.remove(); return; }
    var anim = d.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1)' },
      { transform: 'translate(' + ((x0 + x1) / 2) + 'px,' + (Math.min(y0, y1) - 90) + 'px) scale(1.3)', offset: .5 },
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.4)', opacity: .5 }
    ], { duration: 750, easing: 'cubic-bezier(.5,0,.3,1)' });
    var done = function () {
      if (!d.parentNode) return;
      d.remove();
      cart.classList.remove('bcr-bump'); void cart.offsetWidth; cart.classList.add('bcr-bump');
    };
    anim.onfinish = done;
    setTimeout(done, 1200);
  }, true);


  /* ---------- honest wording fixes for app widgets (bundle offers, order tracking) ---------- */
  function fixBundles() {
    var t = document.getElementById('prvw__block_title');
    if (t && /left in stock|limited stock/i.test(t.textContent)) t.textContent = 'Buy More Save More';
    var l1 = document.getElementById('prvw__label_1'), l2 = document.getElementById('prvw__label_2');
    if (!l1) return;
    var b1 = l1.querySelector('[class*="most_popular_wrapper"]');
    if (!b1 || b1.dataset.bcrDone) return;
    b1.dataset.bcrDone = '1';
    var b2 = l2 && l2.querySelector('[class*="most_popular_wrapper"]');
    var spot = l2 && l2.querySelector('[class*="cbmain--content--right"]');
    if (!b2 && spot) spot.appendChild(b1);   // the single item was tagged: move the tag to the 2-pack
    else b1.style.display = 'none';          // the 2-pack already has its own tag
  }
  function fixTracking() {
    document.querySelectorAll('main *').forEach(function (el) {
      if (el.children.length) return;
      if (/3\s*-\s*10 working days/i.test(el.textContent)) {
        el.textContent = 'Most orders arrive within 6–10 business days (Australia & New Zealand) or 7–15 business days (rest of the world).';
      }
    });
  }
  function fixApps() {
    fixBundles();
    if (/track/.test(location.pathname)) fixTracking();
  }
  // The apps draw these after the page loads (and can redraw them), so keep a light check running
  // on pages that have them; on all other pages it stops after 10 seconds.
  var appTries = 0;
  var appIv = setInterval(function () {
    fixApps();
    appTries++;
    var keep = document.getElementById('prvw__bundle_container') || /track/.test(location.pathname);
    if (appTries > 40 && !keep) clearInterval(appIv);
  }, 400);


  /* ---------- product pages: go straight to checkout after "Add to cart" ---------- */
  // Runs only after the theme confirms the item is in the cart (its own "cart updated" signal),
  // then waits a moment so any free gift (e.g. LockBand buy-1-get-1) is added before moving on.
  // Pages with the bundle app already do this themselves, so they are left alone.
  var going = false;
  function cartSnapshot() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count + ':' + c.total_price; });
  }
  function goToCheckout() {
    var prev = null, same = 0, tries = 0;
    var step = function () {
      cartSnapshot().then(function (snap) {
        tries++;
        same = (snap === prev) ? same + 1 : 0;
        if (same >= 2 || tries >= 10) {
          location.href = '/checkout';
          setTimeout(function () { going = false; }, 4000); // if the move is ever blocked, the normal cart keeps working
          return;
        }
        prev = snap;
        setTimeout(step, 450);
      }).catch(function () { going = false; });
    };
    step();
  }
  document.addEventListener('cart:update', function (e) {
    if (going) return;
    if (!/^\/products\//.test(location.pathname)) return;
    if (window.Shopify && window.Shopify.designMode) return;           // theme editor: checkout can't open there
    if (document.getElementById('prvw__bundle_container')) return;     // bundle app handles these pages
    var d = e.detail && e.detail.data;
    if (!d || d.source !== 'product-form-component' || d.didError) return;
    var t = e.target;
    if (!t || !t.closest || !t.closest('[id*="__main"]')) return;       // only the main product form
    going = true;
    goToCheckout();
  });
  window.addEventListener('pageshow', function () { going = false; }); // coming back with the back button

  function init() { initZoom(); initReveals(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();